export default Object.freeze({
  Parser: 'parser',
  Generic: 'generic',
});
